import pjson from './../package.json';
import keyMirror from 'keymirror';

export const AGD_DOMAIN = 'agd-online.com';
export const REPORTES_DOMAIN = 'reportes.agd-online.com';
export const API_BASE = process.env.REACT_APP_API_AGD;

export const API_VERSION = 'v1/';
export const CLIENT_VERSION = pjson.version;
export const REACT_VERSION = pjson.dependencies.react;

console.log("Versión ".concat(CLIENT_VERSION).concat(" - ".concat(process.env.NODE_ENV)));

export const CONTACTO_WHATSAPP = '5491124115953';


export const STORAGE_KEYS = keyMirror({
    token: null,
    expireDate: null,
    user: null,
    account: null,
    logo: null,
    accessTimes: 0
});

export const HTTP_METHODS = keyMirror({get: null, post: null, put: null});

export const EVENT_KEYS = keyMirror({BLOCK_UI: null, NAVIGATE_TO: null, SHOW_ALERT: null});


export const REPORTES_TABLE_ROWS = 50



// WEBPACK FOOTER //
// ./src/config.js